import { combineReducers } from 'redux';
import auth from './auth.reducer';
import location from './location.reducer';

export const rootReducer = combineReducers({
  auth,
  location,
});
